(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"]) return;
  try {
    
  (() => {
    const initLowkeyTestimonials = () => {
      document.querySelectorAll('[data-lowkey-testimonials]').forEach((section) => {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        const track = section.querySelector('[data-lowkey-testimonials-track]');
        const cards = section.querySelectorAll('.lowkey-testimonial-card');
        const prev = section.querySelector('[data-lowkey-testimonials-prev]');
        const next = section.querySelector('[data-lowkey-testimonials-next]');
        const progress = section.querySelector('[data-lowkey-testimonials-progress]');

        if (!track || !cards.length || !progress) return;

        const update = () => {
          const gap = parseFloat(getComputedStyle(track).gap || 0);
          const width = cards[0].getBoundingClientRect().width + gap;
          const current = Math.min(cards.length, Math.max(0, Math.round(track.scrollLeft / Math.max(1, width))) + 1);
          progress.textContent = String(current).padStart(2, '0');
        };

        const move = (direction) => {
          const gap = parseFloat(getComputedStyle(track).gap || 0);
          const width = cards[0].getBoundingClientRect().width + gap;
          track.scrollBy({ left: direction * width, behavior: 'smooth' });
        };

        prev?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    };

    document.addEventListener('DOMContentLoaded', initLowkeyTestimonials);
    document.addEventListener('shopify:section:load', initLowkeyTestimonials);
    initLowkeyTestimonials();
  })();

  } catch(e) { console.error(e); }
})();
})();
